/**
 * 生成请求签名
 * @author lixiaobin
 */

import crypto from 'crypto-js'

interface Params {
    [key: string]: string
}

function generateRequestSign(params: Params, method: string, timestamp: number): string {
    const paramArray: Array<string> = []
    paramArray.push('timestamp=' + timestamp)
    if (method === 'post') {
        let body = ''
        if (!params) {
            body = ''
        }
        else {
            body = JSON.stringify(params)
        }
        paramArray.push('body=' + body)
    }
    else {
        for ( const item in params) {
            paramArray.push(item + '=' + params[item])
        }
    }
    paramArray.sort()
    const signStr = paramArray.join('&')
    return crypto.MD5(signStr).toString().toUpperCase()
}
export default generateRequestSign
